import { openModal, type ModalHandle } from "@bn-games/ui-shell";

export interface DiscardModalStrings {
  readonly title: string;
  readonly body: string;
  readonly keep: string;
  readonly discard: string;
}

export interface CreateDiscardModalOptions {
  readonly strings: DiscardModalStrings;
  readonly onDiscard: () => void;
  // Optional — fires when the user picks "keep" (closes the modal regardless).
  readonly onKeep?: () => void;
  // Whether clicking the overlay dismisses the modal. Defaults to true (matches
  // the underlying openModal default). Checkers passes false to force a choice.
  readonly dismissible?: boolean;
}

// Open the standard "you have an active game — discard or keep?" modal both
// apps use before starting a new game. Pre-translated strings + caller-supplied
// effect callbacks (the modal only handles UI; the caller still owns the
// recorder.discard() call so it stays close to per-app state machines).
export function createDiscardModal(opts: CreateDiscardModalOptions): ModalHandle {
  const handle: { ref: ModalHandle | null } = { ref: null };
  handle.ref = openModal({
    title: opts.strings.title,
    body: opts.strings.body,
    actions: [
      {
        label: opts.strings.keep,
        onClick: () => {
          handle.ref?.close();
          opts.onKeep?.();
        },
      },
      {
        label: opts.strings.discard,
        primary: true,
        onClick: () => {
          handle.ref?.close();
          opts.onDiscard();
        },
      },
    ],
    dismissible: opts.dismissible,
  });
  return handle.ref;
}
